import * as Yup from "yup";

export default function ChangePwValidationSchema() {
  return Yup.object().shape({
    oldPassword: Yup.string().required('Required'),
    password: Yup.string().required("Required"),
    confirmPassword: Yup.string().required("Required")
  });
}
